import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import useSendWishData from '../../model/hooks/useSendWishData';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { RESET, SEND } from '../../constants/actions';
import content from '../../constants/content';

const { buttons } = content;

export default function Buttons({ isHiddenWishCard, chooseElf }) {
  const callbacks = useApplicationCallbacks();
  const sendWish = useSendWishData({ chooseElf });

  return (
    !isHiddenWishCard && (
      <div className={'wish__content-soc'}>
        {buttons.map((btn) => (
          <CustomButton
            key={btn.callbackKey}
            {...btn}
            customCallbacks={{ [RESET]: callbacks.resetWishData, [SEND]: sendWish }}
          />
        ))}
      </div>
    )
  );
}
